import PropTypes from 'prop-types';
import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';

import * as analytics from '../../../utilities/analytics';
import HintTooltip from '../hint-tooltip';
import { EXT_TOOLTIP_VIEWED } from '../../../constants/events';

import './styles.less';

const whiteLogoMarkElString = `<img alt="loom logo" src="${require('img/icons/loom-logo-mark-white.svg')}" />`;

class CreateHintTooltip extends Component {
  render() {
    const phrase =
      '<div class="tooltip-header">Start a Recording</div>' +
      `<div class="tooltip-text">Click the ${whiteLogoMarkElString} to open the settings menu.<br />
      Once you begin recording, click again to end.</div>`;

    analytics.track(EXT_TOOLTIP_VIEWED, {
      phrase,
    });

    return <HintTooltip content={phrase} />;
  }

  handleClickOutside() {
    this.props.onClose();
  }
}

CreateHintTooltip.propTypes = {
  onClose: PropTypes.func,
};

CreateHintTooltip.defaultProps = {
  onClose: () => {},
};

export default onClickOutside(CreateHintTooltip);
